import React from 'react';

import ArrowLeftRoundedIcon from '@mui/icons-material/ArrowLeftRounded';
import ArrowRightRoundedIcon from '@mui/icons-material/ArrowRightRounded';
import { IconButton } from '@mui/material';
import { DateTime } from 'luxon';

import {
	StyledWeekDayButton,
	StyledWeekDayCircle,
	StyledWeekDayLabel,
	StyledWeekDaySwitcher,
	StyledWeekDays,
	StyledWeekNavigation,
} from './styled';

interface PropsType {
	format: 'day' | 'week';
	dateTime: DateTime<boolean>;
	setDateTime: (newDateTime: DateTime<boolean>) => void;
}

function WeekDaySwitcher({ format, dateTime, setDateTime }: PropsType) {
	if (format !== 'day') {
		return null;
	}

	const weekStart = dateTime.startOf('week');
	const weekDays = Array.from({ length: 7 }, (_, idx) => weekStart.plus({ days: idx }));

	const handleSelectDay = (day: DateTime<boolean>) => {
		if (!day.hasSame(dateTime, 'day')) {
			setDateTime(day);
		}
	};
	const handlePrevWeek = () => {
		setDateTime(dateTime.minus({ weeks: 1 }));
	};
	const handleNextWeek = () => {
		setDateTime(dateTime.plus({ weeks: 1 }));
	};

	return (
		<StyledWeekDaySwitcher>
			<StyledWeekNavigation>
				<IconButton onClick={handlePrevWeek}>
					<ArrowLeftRoundedIcon />
				</IconButton>
				<StyledWeekDays>
					{weekDays.map((day) => {
						const isSelected = day.hasSame(dateTime, 'day');
						return (
							<StyledWeekDayButton
								$selected={isSelected}
								key={day.toISODate()}
								onClick={() => handleSelectDay(day)}
							>
								<StyledWeekDayLabel $selected={isSelected}>
									{day.toFormat('ccc')}
								</StyledWeekDayLabel>
								<StyledWeekDayCircle $selected={isSelected}>
									{day.toFormat('d')}
								</StyledWeekDayCircle>
							</StyledWeekDayButton>
						);
					})}
				</StyledWeekDays>
				<IconButton onClick={handleNextWeek}>
					<ArrowRightRoundedIcon />
				</IconButton>
			</StyledWeekNavigation>
		</StyledWeekDaySwitcher>
	);
}

export default WeekDaySwitcher;
